//=================================================
//    summary: DCP Progress OverView -- Hook
//
//    remarks: 000 Tim 2021/11/04 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssProgressOverView from './ProgressOverView.module.scss'

import {
    GlobalLibs
} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false

let mstrBookSeqNo = ""
// #endregion Member Variables


const COMP_NAME = "ProgressOverView"

function ProgressOverView(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [lessonID, setLessonID] = useState(props.CurrLessonID)
    // #region Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
            setUpdateDataTime(0)
        }
    }, [props.BookSeqNo])


    // #region OnTapHandler
    /*===========================================
    summary: Lesson 按鈕 處理
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function LessonOnTapHandler(LessonIndex)
    {
        console.log(COMP_NAME + ".LessonOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setLessonID(window.gSession.App.BookDef[mstrBookSeqNo].Lesson[LessonIndex].ID)

        if (
            (typeof(props.CallbackRef) !== 'undefined') &&
            (props.CallbackRef !== null)
            )
        {
            let objCallbackData = {
                "Action": "OverViewLessonOnTap",
                "LessonIndex": LessonIndex,
                "LessonID": window.gSession.App.BookDef[mstrBookSeqNo].Lesson[LessonIndex].ID
            }
            props.CallbackRef(objCallbackData)
        }
    } // end of LessonOnTapHandler

    /*===========================================
    summary: 學生名稱 按鈕 處理
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function StudentNameOnTapHandler(StudentIndex)
    {
        console.log(COMP_NAME + ".StudentNameOnTapHandler: ", StudentIndex)

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (typeof(props.CallbackRef) !== 'undefined') &&
            (props.CallbackRef !== null)
            )
        {
            let objCallbackData = {
                "Action": "StudentNameOnTap",
                "StudentIndex": StudentIndex
            }
            props.CallbackRef(objCallbackData)
        }
    } // end of StudentNameOnTapHandler

    /*===========================================
    summary: Lesson Status 按鈕 處理
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function LessonStatusOnTapHandler(LessonIndex)
    {
        console.log(COMP_NAME + ".LessonStatusOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (typeof(props.CallbackRef) !== 'undefined') &&
            (props.CallbackRef !== null)
            )
        {
            let objCallbackData = {
                "Action": "OverViewLessonStatusOnTap",
                "LessonIndex": LessonIndex,
                "LessonID": window.gSession.App.BookDef[mstrBookSeqNo].Lesson[LessonIndex].ID
            }
            props.CallbackRef(objCallbackData)
        }
    } // end of LessonStatusOnTapHandler
    // #endregion OnTapHandler

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        mstrBookSeqNo = props.BookSeqNo.toString().PadLeft(2)

        setUpdateDataTime(new Date().getTime())
    } // end of PaintedMe
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 Lesson單元 Cls
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function GetLessonUnitCls(StateLessonID, LessonData) 
    {
        let objCls = cssProgressOverView.divLessonText

        if (parseInt(StateLessonID) === parseInt(LessonData.ID))
        {
            objCls = cssProgressOverView.divLessonSelected
        }

        return objCls
    } // end of GetLessonUnitCls

    /*===========================================
    summary: 取得 Lesson單元 Cls
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function GetProgressSectionCls() 
    {
        let objCls = cssProgressOverView.divProgressSectionCell

        if (parseInt(props.BookSeqNo) <= 2)
        {
            objCls = cssProgressOverView.divProgressSectionCell
        }
        else
        {
            objCls = cssProgressOverView.divProgressSectionCellNoPinyin
        }

        return objCls
    } // end of GetProgressSectionCls

    /*===========================================
    summary: 取得 單元 狀態顏色
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function GetSectionBGCls (SubLessonStatus)
    {   
        let objSectionBGCls = cssProgressOverView.divSectionNotSubmitted

        switch (SubLessonStatus)
        {
            case window.gNewAssignmentStatusEnum.NotSubmitted:
                objSectionBGCls = cssProgressOverView.divSectionNotSubmitted
                break
            case window.gNewAssignmentStatusEnum.GradePending:
                objSectionBGCls = cssProgressOverView.divSectionGradePending
                break
            case window.gNewAssignmentStatusEnum.NeedHelp:
                objSectionBGCls = cssProgressOverView.divSectionNeedHelp
                break
            case window.gNewAssignmentStatusEnum.Completed:
                objSectionBGCls = cssProgressOverView.divSectionCompleted
                break
            default:
                break
        } // end of switch (SubLessonStatus)
        
        return objSectionBGCls;
    } // end of GetSectionBGCls
    // #endregion Get ClassName

    // #region Render元件
    /*===========================================
    summary: ProgressNameCell 顯示Component  
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentProgressNameCell({ReportData, ReportIndex})
    {   
        let strDisplayName = window.Globals.GetUserDisplayName(ReportData.FirstName, ReportData.LastName, ReportData.LoginName)

        return(
            <div className={cssProgressOverView.divProgressNameCell} onClick={() => StudentNameOnTapHandler(ReportIndex)}>
                {strDisplayName}
            </div>
        )
    } // end of ComponentProgressNameCell                        

    /*===========================================
    summary: Title 顯示Component  
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentTitle()
    {   
        return(
            <div className={cssProgressOverView.divTitle}>
                {window.gAppUI.LBL_Name + ' \\ ' + window.gAppUI.LBL_Lessons}
            </div>
        )
    } // end of ComponentTitle
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render 進度表 SectionList
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderReportLessonStatusListWrapper(ReportData)
    {
        return(
            <>
                {ReportData.LessonStatus.map((LessonStatus, LessonIndex) => 
                    <div key={LessonIndex} className={GetProgressSectionCls()} onClick={() => LessonStatusOnTapHandler(LessonIndex)}>
                        {LessonStatus.map((SubLessonStatus, SubLessonIndex) => 
                            <div key={SubLessonIndex} className={GetSectionBGCls(SubLessonStatus)}/>
                        )}
                    </div>
                )}
            </>
        )
    } // end of RenderReportLessonStatusListWrapper

    /*===========================================
    summary: Render 進度表 Report 列
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderReportRowWrapper()
    {
        return(
            <div className={cssProgressOverView.divProgressMain}>
                {props.ReportDataList.map((ReportData, ReportIndex) => 
                    <div key={ReportIndex} className={cssProgressOverView.divProgressRow}>
                        <ComponentProgressNameCell ReportData={ReportData} ReportIndex={ReportIndex} />
                        
                        {RenderReportLessonStatusListWrapper(ReportData)}
                    </div>
                )}
            </div>
        )
    } // end of RenderReportRowWrapper

    /*===========================================
    summary: Render LessonSelectedLine 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderLessonSelectedLineWrapper(StateLessonID, LessonData)
    {
        if (parseInt(StateLessonID) === parseInt(LessonData.ID))
        {
            return (
                <div className={cssProgressOverView.divSelectedLine}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderLessonSelectedLineWrapper

    /*===========================================
    summary: Render LessonUnit 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderLessonUnitWrapper(LessonData, LessonIndex, StateLessonID)
    {
        return (
            <div className={cssProgressOverView.divLessonUnit} onClick={() => LessonOnTapHandler(LessonIndex)}>
                <div className={GetLessonUnitCls(StateLessonID, LessonData)}>
                    {LessonData.PrefixName.slice(7)}
                </div>

                {RenderLessonSelectedLineWrapper(StateLessonID, LessonData)}
            </div>
        )
    } // end of RenderLessonUnitWrapper

    /*===========================================
    summary: Render Lesson Row 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderLessonRowWrapper()
    {
        return (
            <div className={cssProgressOverView.divLessonRow}>
                <ComponentTitle />
                
                {window.gSession.App.BookDef[mstrBookSeqNo].Lesson.map((LessonData, LessonIndex) =>  
                    <div key={LessonIndex} className={cssProgressOverView.divBulletinRow}>
                        {RenderLessonUnitWrapper(LessonData, LessonIndex, lessonID)}
                    </div>
                )}
            </div>
        )
    } // end of RenderLessonRowWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderMainWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssProgressOverView.divMain}>
                    {RenderLessonRowWrapper()}
                    {RenderReportRowWrapper()}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper(updateDataTime)}
        </>
    )
    // #endregion Render
}
export default ProgressOverView